import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import type { UserVerificationProcessSubmitResultApi } from 'api-typings/users/users';
import { transformUserVerificationProcess } from './user-verification-processes.transformers';
import type { UserVerificationProcessesCollection } from './user-verification-processes.types';

function isUserVerificationProcessSubmitResult(
  result: UserVerificationProcessesCollection['Backend']['Push']['ReturnType'],
): result is UserVerificationProcessSubmitResultApi {
  return 'user_verification_process' in result;
}

export function userVerificationProcessesReducer(
  state: CollectionStateSlice<UserVerificationProcessesCollection> = {},
  action: CollectionActions<UserVerificationProcessesCollection>,
): CollectionStateSlice<UserVerificationProcessesCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'userVerificationProcesses') {
        const { result, ref, order } = action.payload;

        return mergeDocuments<UserVerificationProcessesCollection>(
          state,
          transformIntoDocuments(
            result.user_verification_processes,
            transformUserVerificationProcess,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'userVerificationProcesses') {
        const { ref, result } = action.payload;

        if (result && isUserVerificationProcessSubmitResult(result)) {
          return mergeWebsocketDocuments<UserVerificationProcessesCollection>(
            state,
            transformIntoDocuments(
              [result.user_verification_process],
              transformUserVerificationProcess,
            ),
            ref,
          );
        }
      }

      return state;
    }
    default:
      return state;
  }
}
